export const MONTHLY = 1;
export const YEARLY = 2;
export const TRIAL = 3;



// WEBPACK FOOTER //
// ./app/constants/PLANS.ts